import React, { useContext, useState } from "react";
import GridItemText from "./GridItemText";
import { Grid, MenuItem, Select, useMediaQuery } from "@mui/material";
import SearchButtonArea from "./SearchButtonArea";
import { searchBranch } from "../../../util/bankCode";
import module from "./FormSelfInformation.module.css";
import { useTheme } from "@emotion/react";
import { RewardSettingContext } from "../../../contexts/RewardSettingContext";

const BranchForm = () => {
  const [inputtedBranchName, setInputtedBranchName] = useState("");
  const [branches, setBranches] = useState([]);
  const [notFoundBranch, setNotFoundBranch] = useState("");
  const { bank, setBranchName, clearBankBranch } =
    useContext(RewardSettingContext);
  const { bankCode, branchName, branchCode } = bank.inputted;
  const theme = useTheme();
  const isPc = useMediaQuery(theme.breakpoints.up("md"));

  if (!bankCode) return null;

  const getBranchInfo = async () => {
    try {
      setNotFoundBranch("");
      const branches = await searchBranch(bankCode, inputtedBranchName);
      if (branches.length === 0) {
        setNotFoundBranch("該当する支店が見つかりませんでした");
        return null;
      }
      setBranches(branches);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeBranchName = (e) => {
    setInputtedBranchName(e.target.value);
  };

  const handleClear = () => {
    setInputtedBranchName("");
    setBranches([]);
    clearBankBranch();
  };

  const handleSelect = (e) => {
    const branch = branches.find((branch) => branch.code === e.target.value);
    setBranches([]);
    setInputtedBranchName("");
    setBranchName(branch.name, branch.code);
  };

  const isDisabledClear = () => {
    if (!branchCode) return true;
    if (bank.invalidBank) return false;
    if (bank.saved) return true;
    return false;
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          marginBottom: isPc ? "0px" : "24px",
          justifyContent: isPc ? "center" : "end",
        }}
      >
        <GridItemText
          label="支店名"
          xs={isPc ? 8 : 12}
          placeholder={"例：中之島支店"}
          name={"branch_name"}
          onChange={handleChangeBranchName}
          defaultValue={inputtedBranchName || branchName}
          error={notFoundBranch}
        />
        <SearchButtonArea
          handleSearch={getBranchInfo}
          handleClear={handleClear}
          clearDisabled={isDisabledClear()}
        />
      </Grid>
      {branches.length > 0 && (
        <Grid item xs={6} sx={{ textAlign: "left", marginBottom: "24px" }}>
          <label className={module.label}>{"銀行を選択してください"}</label>
          <span className={module.labelRequire}>*</span>
          <Select fullWidth value={bankCode || ""} onChange={handleSelect}>
            <MenuItem value={""}>{"選択してください"}</MenuItem>
            {branches.map((branch) => (
              <MenuItem value={branch.code}>{branch.name}</MenuItem>
            ))}
          </Select>
        </Grid>
      )}
      {branchCode && (
        <GridItemText
          label="支店番号"
          placeholder={"001"}
          name={"branch_code"}
          disabled
          value={branchCode}
        />
      )}
    </>
  );
};

export default BranchForm;
